/* ==============================
Start detect tabbing 
============================== */
function handleFirstTab(e) {
  if (e.key === 'Tab') {
    document.body.classList.add('user-is-tabbing')
    window.removeEventListener('keydown', handleFirstTab)
    window.addEventListener('mousedown', handleMouseDownOnce)
    window.addEventListener('touchstart', handleMouseDownOnce)
  }
}

function handleMouseDownOnce() {
  document.body.classList.remove('user-is-tabbing')
  window.removeEventListener('mousedown', handleMouseDownOnce)
  window.removeEventListener('touchstart', handleMouseDownOnce)
  window.addEventListener('keydown', handleFirstTab)
}

window.addEventListener('keydown', handleFirstTab)
/* ==============================
End detect tabbing 
============================== */

/* ==============================
Start focus trap
============================== */
const trapStack = []
const focusableSelectors =
  "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe, [contenteditable]"

function getFocusableElements(container) {
  return Array.from(container.querySelectorAll(focusableSelectors)).filter(isVisible)
}

function isVisible(el) {
  if (el.hidden) return false

  const style = getComputedStyle(el)
  if (
    style.display === 'none' ||
    style.visibility === 'hidden' ||
    style.opacity === '0' ||
    style.pointerEvents === 'none'
  ) {
    return false
  }

  const rect = el.getBoundingClientRect()
  return !!(rect.width || rect.height)
}

function handleFocusTrap(e) {
  if (e.key !== 'Tab' || trapStack.length === 0) return

  const currentTrap = trapStack[trapStack.length - 1]
  const { container } = currentTrap

  const elements = getFocusableElements(container)
  if (!elements.length) return

  const first = elements[0]
  const last = elements[elements.length - 1]

  if (e.shiftKey) {
    if (document.activeElement === first) {
      e.preventDefault()
      last.focus()
    }
  } else {
    if (document.activeElement === last) {
      e.preventDefault()
      first.focus()
    }
  }
}

document.addEventListener('keydown', handleFocusTrap)

function trapFocus(container, elementToFocus = null) {
  if (trapStack.length && trapStack[trapStack.length - 1].container === container) return

  const elementToReturnTo = elementToFocus || document.activeElement

  trapStack.push({
    container,
    elementToReturnTo,
  })

  const elements = getFocusableElements(container)
  if (elements.length) {
    elements[0].focus()
  }
}

function removeTrapFocus(container) {
  const index = trapStack.findIndex((trap) => trap.container === container)

  if (index === -1) return

  const removedTrap = trapStack.splice(index, 1)[0]
  const { elementToReturnTo } = removedTrap

  const isElementStillValid = elementToReturnTo && document.body.contains(elementToReturnTo)

  if (isElementStillValid && typeof elementToReturnTo.focus === 'function') {
    elementToReturnTo.focus()
  } else {
    if (trapStack.length > 0) {
      const previousTrap = trapStack[trapStack.length - 1]
      const fallbackElements = getFocusableElements(previousTrap.container)

      if (fallbackElements.length > 0) {
        fallbackElements[0].focus()
      }
    }
  }
}

function restoreFocusTrap() {
  if (!trapStack || trapStack.length === 0) return
  const currentTrap = trapStack[trapStack.length - 1]
  const { container } = currentTrap

  if (!container || !document.contains(container)) return
  const elements = getFocusableElements(container)

  if (elements && elements.length > 0) {
    elements[0].focus()
  }
}
/* ==============================
End focus trap
============================== */

/* ==============================
Start lock scroll
============================== */
let scrollLockCount = 0
let scrollbarSide = null

function getScrollbarWidth() {
  return window.innerWidth - document.documentElement.clientWidth
}

function isTouchDevice() {
  return 'ontouchstart' in window || navigator.maxTouchPoints > 0
}

function detectScrollbarSide() {
  if (scrollbarSide) return scrollbarSide

  const div = document.createElement('div')
  div.style.width = '100px'
  div.style.height = '100px'
  div.style.overflow = 'scroll'
  div.style.position = 'absolute'
  div.style.top = '-9999px'
  document.body.appendChild(div)
  scrollbarSide = div.offsetLeft === 0 && div.clientLeft > 0 ? 'left' : 'right'
  document.body.removeChild(div)
  return scrollbarSide
}

function lockScroll() {
  if (scrollLockCount === 0) {
    if (!isTouchDevice()) {
      const scrollbarWidth = getScrollbarWidth()
      if (scrollbarWidth > 0) {
        const side = detectScrollbarSide()
        if (side === 'left') {
          document.body.style.paddingLeft = `${scrollbarWidth}px`
        } else {
          document.body.style.paddingRight = `${scrollbarWidth}px`
        }
      }
    }
    document.body.classList.add('overflow-hidden')
  }
  scrollLockCount++
}

function unlockScroll() {
  if (scrollLockCount > 0) {
    scrollLockCount--
  }

  if (scrollLockCount === 0) {
    document.body.classList.remove('overflow-hidden')
    document.body.style.paddingRight = ''
    document.body.style.paddingLeft = ''
  }
}
/* ==============================
End lock scroll
============================== */

/* ==============================
Start Debounce
============================== */
function debounce(fn, wait) {
  let t
  return (...args) => {
    clearTimeout(t)
    t = setTimeout(() => fn.apply(this, args), wait)
  }
}
/* ==============================
End Debounce
============================== */

/* ==============================
Start get cart sections
============================== */
function getCartSections() {
  const sections = new Set(['cart-bubble'])

  document.querySelectorAll('[data-cart-section]').forEach((element) => {
    sections.add(element.dataset.sectionId || element.id)
  })

  return Array.from(sections)
}
/* ==============================
End get cart sections
============================== */

/* ==============================
Start header
============================== */
class HeaderMenu extends HTMLElement {
  constructor() {
    super()

    this.megaMenus = this.querySelectorAll('.mega-menu')
    if (this.megaMenus.length > 0) this.initMegaMenus()

    this.linksWithSubmenu = this.querySelectorAll('li.has-submenu a[aria-haspopup="true"]')

    this.linksWithSubmenu.forEach((link) => {
      link.addEventListener('keydown', this.onKeydown.bind(this))
      link.addEventListener('pointerdown', this.onPointerdown.bind(this))
    })

    this.addEventListener('focusout', this.onFocusOut)

    window.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') this.onEscKey()
    })

    document.addEventListener('shopify:block:select', this.onMegaMenuBlockSelect.bind(this))
    document.addEventListener('shopify:block:deselect', this.onMegaMenuBlockDeselect.bind(this))
  }

  onKeydown(e) {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault()
      this.toggleSubmenu(e.target)
    }
  }

  onPointerdown(e) {
    if (e.pointerType === 'touch') {
      e.preventDefault()
      e.target.addEventListener('click', (event) => event.preventDefault(), { once: true })
    }
  }

  onFocusOut(e) {
    const currentLink = e.target
    const nextLink = e.relatedTarget
    const dropdownItem = currentLink.closest('.dropdown__item')
    const dropdownLink = dropdownItem?.querySelector('.dropdown__link')
    const topLevelItem = currentLink.closest('.header-menu__item')
    const topLevelLink = topLevelItem.querySelector('.header-menu__link')

    if (dropdownItem) {
      if (dropdownItem.contains(nextLink)) return
      const hasSubmenu = dropdownLink.hasAttribute('aria-haspopup') ? true : false
      if (hasSubmenu) {
        const isOpen = dropdownLink.getAttribute('aria-expanded') === 'true'
        if (isOpen) {
          this.closeSubmenu(dropdownLink)
        }
      }
    }

    if (topLevelItem.contains(nextLink)) return
    const hasSubmenu = topLevelLink.hasAttribute('aria-haspopup') ? true : false
    if (hasSubmenu) {
      const isOpen = topLevelLink.getAttribute('aria-expanded') === 'true'
      if (isOpen) {
        this.closeSubmenu(topLevelLink)
      }
    }
  }

  toggleSubmenu(link) {
    const isOpen = link.getAttribute('aria-expanded') === 'true'
    isOpen ? this.closeSubmenu(link) : this.openSubmenu(link)
  }

  openSubmenu(link) {
    const li = link.closest('li')
    link.setAttribute('aria-expanded', 'true')
    li.classList.add('open')
  }

  closeSubmenu(link) {
    const li = link.closest('li')
    link.setAttribute('aria-expanded', 'false')
    li.classList.remove('open')
  }

  onEscKey() {
    this.linksWithSubmenu.forEach((link) => {
      const isOpen = link.getAttribute('aria-expanded') === 'true'

      if (isOpen) {
        const topLevelLink = link.closest('li.header-menu__item').querySelector('.header-menu__link')
        this.closeSubmenu(link)
        topLevelLink.focus()
      }
    })
  }

  initMegaMenus() {
    this.megaMenus.forEach((megaMenu) => {
      const item = this.querySelector(`.${megaMenu.dataset.item}`)
      if (!item) {
        megaMenu.remove()
        return
      }

      let submenuContainer = item.querySelector('.submenu')

      if (!submenuContainer) {
        submenuContainer = this.enableSubmenu(item)
      }

      submenuContainer.innerHTML = ''
      submenuContainer.appendChild(megaMenu)
      submenuContainer.classList.remove('submenu--dropdown')
      submenuContainer.classList.add('submenu--mega-menu')
    })
  }

  enableSubmenu(item) {
    // 1. li: add class 'has-submenu'
    item.classList.add('has-submenu')

    // 2. a: add aria attributes
    const link = item.querySelector('.header-menu__link')
    link.setAttribute('aria-haspopup', 'true')
    link.setAttribute('aria-expanded', 'false')

    // 3. create submenu container
    const submenuContainer = document.createElement('div')
    submenuContainer.classList.add('submenu')
    item.appendChild(submenuContainer)

    return submenuContainer
  }

  onMegaMenuBlockSelect(e) {
    if (!this.contains(e.target)) return
    let item
    if (e.target.classList.contains('mega-menu')) {
      item = this.querySelector(`.${e.target.dataset.item}`)
    } else if (e.target.classList.contains('mega-menu__column')) {
      item = this.querySelector(`.${e.target.closest('.mega-menu').dataset.item}`)
    }
    const link = item?.querySelector('.header-menu__link')
    if (item && link) this.openSubmenu(link)
  }

  onMegaMenuBlockDeselect(e) {
    if (!this.contains(e.target)) return
    let item
    if (e.target.classList.contains('mega-menu')) {
      item = this.querySelector(`.${e.target.dataset.item}`)
    } else if (e.target.classList.contains('mega-menu__column')) {
      item = this.querySelector(`.${e.target.closest('.mega-menu').dataset.item}`)
    }
    const link = item?.querySelector('.header-menu__link')
    if (item && link) this.closeSubmenu(link)
  }
}

customElements.define('header-menu', HeaderMenu)

class MobileMenu extends HTMLElement {
  constructor() {
    super()
    this.toggleBtn = this.querySelector('.mobile-menu__btn')
    this.links = this.querySelectorAll('a.has-submenu')
    this.submenus = this.querySelectorAll('.submenu')
    this.backBtns = this.querySelectorAll('.submenu__link--back')

    this.toggleBtn.addEventListener('click', this.onToggleBtnClick.bind(this))
    this.links.forEach((link) => link.addEventListener('click', this.onLinksClick.bind(this)))
    this.backBtns.forEach((btn) => btn.addEventListener('click', this.onBackBtnClick.bind(this)))
    window.addEventListener('resize', this.onResize.bind(this))
    window.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') this.closeMobileMenu()
    })
    document.addEventListener('search:open', this.closeMobileMenu.bind(this))

    document.addEventListener('shopify:section:load', this.onSectionLoad.bind(this))
  }

  onToggleBtnClick() {
    if (this.classList.contains('open')) {
      this.closeMobileMenu()
    } else {
      this.openMobileMenu()
    }
  }

  openMobileMenu() {
    if (this.classList.contains('open')) return
    this.classList.add('open')
    this.toggleBtn.setAttribute('aria-expanded', 'true')
    lockScroll()
    this.addEventListener(
      'transitionend',
      () => {
        trapFocus(this)
      },
      { once: true }
    )
  }

  closeMobileMenu() {
    if (!this.classList.contains('open')) return
    this.classList.remove('open')
    this.toggleBtn.setAttribute('aria-expanded', 'false')
    unlockScroll()
    this.addEventListener(
      'transitionend',
      () => {
        this.closeSubmenus()
        removeTrapFocus(this)
      },
      { once: true }
    )
  }

  closeSubmenus() {
    this.submenus.forEach((submenu) => {
      if (submenu.classList.contains('open')) {
        const parentLink = submenu.closest('li').querySelector('a')

        parentLink.setAttribute('aria-expanded', 'false')
        submenu.classList.remove('open')
        removeTrapFocus(submenu)
      }
    })
  }

  onLinksClick(e) {
    e.preventDefault()
    const link = e.currentTarget
    const submenu = link.closest('li').querySelector('.submenu')

    link.setAttribute('aria-expanded', 'true')
    submenu.classList.add('open')
    submenu.addEventListener(
      'transitionend',
      () => {
        trapFocus(submenu)
      },
      { once: true }
    )
  }

  onBackBtnClick(e) {
    const btn = e.currentTarget
    const submenu = btn.closest('.submenu')
    const parentLink = submenu.closest('li').querySelector('a')

    parentLink.setAttribute('aria-expanded', 'false')
    submenu.classList.remove('open')
    submenu.addEventListener(
      'transitionend',
      () => {
        removeTrapFocus(submenu)
      },
      { once: true }
    )
  }

  onResize() {
    if (window.innerWidth >= 990) this.closeMobileMenu()
  }

  onSectionLoad(e) {
    if (window.innerWidth < 990 && e.target.contains(this)) {
      unlockScroll()
    }
  }
}

customElements.define('mobile-menu', MobileMenu)

class CartBubble extends HTMLElement {
  constructor() {
    super()
    this.sectionId = this.id

    document.addEventListener('cart:add', this.updateCartBubble.bind(this))
    document.addEventListener('cart:update', this.updateCartBubble.bind(this))
    document.addEventListener('cart:error', this.updateCartBubble.bind(this))
  }

  updateCartBubble(e) {
    const { cartData } = e.detail

    if (cartData && cartData.sections && cartData.sections[this.sectionId]) {
      const parsedHTML = new DOMParser().parseFromString(cartData.sections[this.sectionId], 'text/html')
      const incomingSection = parsedHTML.getElementById(this.sectionId)
      if (!incomingSection) return

      this.innerHTML = incomingSection.innerHTML
    }
  }
}

customElements.define('cart-bubble', CartBubble)

class SearchToggle extends HTMLElement {
  constructor() {
    super()
    this.button = this.querySelector('button')

    this.button.addEventListener('click', this.onButtonClick.bind(this))
    document.addEventListener('search:open', this.open.bind(this))
    document.addEventListener('search:close', this.close.bind(this))
  }

  onButtonClick(e) {
    e.preventDefault()
    const isExpanded = this.button.getAttribute('aria-expanded') === 'true'

    if (isExpanded) {
      document.dispatchEvent(new CustomEvent('search:close'))
    } else {
      document.dispatchEvent(new CustomEvent('search:open'))
    }
  }

  open() {
    this.button.setAttribute('aria-expanded', 'true')
  }

  close() {
    this.button.setAttribute('aria-expanded', 'false')
  }
}

customElements.define('search-toggle', SearchToggle)
/* ==============================
End header
============================== */

/* ==============================
Start block link
============================== */
// Fixes the issue where an outer link may contain inner RTE links.
// <block-link href=""></block-link>
class BlockLink extends HTMLElement {
  constructor() {
    super()
    this.initLink()
    this.href = this.getAttribute('href')

    this.addEventListener('click', this.onClick.bind(this))
    this.addEventListener('keydown', this.onKeyDown.bind(this))
  }

  initLink() {
    this.setAttribute('tabindex', '0')
    this.setAttribute('role', 'link')
  }

  onClick(e) {
    if (e.target.closest('a')) return
    if (!this.href) return

    if (e.ctrlKey || e.metaKey || e.button === 1) {
      window.open(this.href, '_blank')
    } else {
      window.location.href = this.href
    }
  }

  onKeyDown(e) {
    if (e.key === 'Enter' && !e.target.closest('a')) {
      e.preventDefault()
      if (this.href) window.location = this.href
    }
  }
}

customElements.define('block-link', BlockLink)
/* ==============================
End block link
============================== */

/* ==============================
Start layout slider
============================== */
class LayoutSlider extends HTMLElement {
  constructor() {
    super()
    this.slider = this.querySelector('.swiper')
    this.sliderWrapper = this.slider?.querySelector('.swiper-wrapper')
    this.slides = this.getVisibleChildren(this.sliderWrapper)
    this.slidesPerView = parseFloat(this.getAttribute('slides'))
    this.tabletSlidesPerView = parseFloat(this.getAttribute('tablet-slides'))
    this.mobileSlidesPerView = parseFloat(this.getAttribute('mobile-slides'))
    this.autoplay = this.hasAttribute('autoplay')
      ? { delay: this.getAttribute('delay'), pauseOnMouseEnter: true }
      : false
    this.loop = this.hasAttribute('loop')
    this.buttonPrev = this.querySelector('.swiper-button-prev')
    this.buttonNext = this.querySelector('.swiper-button-next')
    this.scrollbar = this.slider.querySelector('.swiper-scrollbar')
    this.swiper = null
    this.mobileOnly = this.hasAttribute('mobile-only') ? '(max-width: 749px)' : false
    this.spaceBetween = parseFloat(this.getAttribute('gap'))
    this.tabletSpaceBetween = parseFloat(this.getAttribute('tablet-gap'))
    this.mobileSpaceBetween = parseFloat(this.getAttribute('mobile-gap'))

    if (this.slides.length) {
      this.slides.forEach((slide) => slide.classList.add('swiper-slide'))

      if (this.mobileOnly) {
        this.mediaQuery = window.matchMedia(this.mobileOnly)
        this.checkBreakpoint(this.mediaQuery)
        this.mediaQuery.addEventListener('change', this.checkBreakpoint.bind(this))
      } else {
        this.createSlider()
      }

      this.updateButtonsPosition()
      setTimeout(() => this.updateButtonsPosition(), 300)

      this.resizeObserver = new ResizeObserver(() => this.updateButtonsPosition())
      this.resizeObserver.observe(this)
    }

    document.addEventListener('shopify:block:select', this.onBlockSelect.bind(this))
  }

  getVisibleChildren(parent) {
    if (!parent) return []

    const invalid = ['STYLE', 'SCRIPT', 'TEMPLATE', 'NOSCRIPT', 'LINK', 'META']
    const visible = []

    Array.from(parent.children).forEach((el) => {
      if (invalid.includes(el.tagName)) return

      const style = window.getComputedStyle(el)
      if (style.display === 'none' || style.visibility === 'hidden') return

      if (!el.classList.contains('swiper-slide')) {
        const wrapper = document.createElement('div')
        wrapper.classList.add('swiper-slide')
        parent.insertBefore(wrapper, el)
        wrapper.appendChild(el)
        visible.push(wrapper)
      } else {
        visible.push(el)
      }
    })

    return visible
  }

  checkBreakpoint(e) {
    if (e.matches) {
      this.classList.remove('slider-disabled')
      if (!this.swiper) this.createSlider()
    } else {
      this.classList.add('slider-disabled')
      if (this.swiper) this.destroySlider()
    }
  }

  createSlider() {
    this.sliderDirection()

    const options = {
      slidesPerView: this.mobileSlidesPerView,
      spaceBetween: this.mobileSpaceBetween,
      breakpoints: {
        750: {
          slidesPerView: this.tabletSlidesPerView,
          spaceBetween: this.tabletSpaceBetween,
        },
        990: {
          slidesPerView: this.slidesPerView,
          spaceBetween: this.spaceBetween,
        },
      },
      autoplay: this.autoplay,
      loop: this.loop,
      scrollbar: {
        el: this.scrollbar,
        draggable: true,
      },
      navigation: {
        prevEl: this.buttonPrev,
        nextEl: this.buttonNext,
        addIcons: false,
      },
      a11y: {
        prevSlideMessage: this.buttonPrev?.dataset.label,
        nextSlideMessage: this.buttonNext?.dataset.label,
      },
    }

    this.swiper = new Swiper(this.slider, options)

    // Show UI
    if (this.buttonPrev) this.buttonPrev.style.display = ''
    if (this.buttonNext) this.buttonNext.style.display = ''
    if (this.scrollbar) this.scrollbar.style.display = ''
  }

  sliderDirection() {
    const isRTL = document.documentElement.dir === 'rtl' ? true : false
    if (isRTL) this.slider.setAttribute('dir', 'rtl')
  }

  destroySlider() {
    if (!this.swiper) return

    this.swiper.destroy(true, true)
    this.swiper = null

    // Hide UI
    if (this.buttonPrev) this.buttonPrev.style.display = 'none'
    if (this.buttonNext) this.buttonNext.style.display = 'none'
    if (this.scrollbar) this.scrollbar.style.display = 'none'
  }

  updateButtonsPosition() {
    if (this.customButtonsPositionApplied) {
      this.customButtonsPosition(this.customButtonsPositionElement)
      return
    }

    if (!this.buttonPrev || !this.buttonNext) return

    const wrapperRect = this.sliderWrapper.getBoundingClientRect()
    const height = wrapperRect.height

    if (height) {
      this.buttonPrev.style.insetBlockStart = `${height / 2}px`
      this.buttonNext.style.insetBlockStart = `${height / 2}px`
    } else {
      this.buttonPrev.style.insetBlockStart = `50%`
      this.buttonNext.style.insetBlockStart = `50%`
    }

    setTimeout(() => {
      if (!this.buttonPrev.classList.contains('transition')) this.buttonPrev.classList.add('transition')
      if (!this.buttonNext.classList.contains('transition')) this.buttonNext.classList.add('transition')
    }, 300)
  }

  customButtonsPosition(element = this.customButtonsPositionElement) {
    this.customButtonsPositionApplied = true
    this.customButtonsPositionElement = element

    if (!this.buttonPrev || !this.buttonNext) return

    const elementRect = element?.getBoundingClientRect()
    const height = elementRect?.height

    if (height) {
      this.buttonPrev.style.insetBlockStart = `${height / 2}px`
      this.buttonNext.style.insetBlockStart = `${height / 2}px`
    } else {
      this.buttonPrev.style.insetBlockStart = `50%`
      this.buttonNext.style.insetBlockStart = `50%`
    }

    setTimeout(() => {
      if (!this.buttonPrev.classList.contains('transition')) this.buttonPrev.classList.add('transition')
      if (!this.buttonNext.classList.contains('transition')) this.buttonNext.classList.add('transition')
    }, 300)
  }

  onBlockSelect(e) {
    if (!this.contains(e.target)) return
    if (!this.swiper) return
    const slide = e.target.closest('.swiper-slide')
    const index = this.slides.indexOf(slide)
    if (index !== -1) {
      this.swiper.slideTo(index, 0)
    }
  }
}

customElements.define('layout-slider', LayoutSlider)
/* ==============================
End layout slider
============================== */

/* ==============================
Start accordion item
============================== */
class AccordionItem extends HTMLElement {
  constructor() {
    super()
    this.header = this.querySelector('.accordion-item__header')
    this.contentWrapper = this.querySelector('.accordion-item__content-wrapper')
    this.content = this.querySelector('.accordion-item__content')

    this.adjustHeight()

    this.header.addEventListener('click', this.onHeaderClick.bind(this))
    this.header.addEventListener('keydown', this.onKeydown.bind(this))

    this.resizeObserver = new ResizeObserver(() => this.adjustHeight())
    this.resizeObserver.observe(this.content)
  }

  onHeaderClick() {
    this.classList.toggle('accordion-item--open')
    this.adjustHeight()
    this.updateAriaAttributes()
  }

  onKeydown(e) {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault()
      this.onHeaderClick()
    }
  }

  adjustHeight() {
    if (this.classList.contains('accordion-item--open')) {
      this.contentWrapper.style.maxHeight = getComputedStyle(this.content).height
    } else {
      this.contentWrapper.style.maxHeight = 0
    }
  }

  updateAriaAttributes() {
    this.header.setAttribute('aria-expanded', this.classList.contains('accordion-item--open'))
    this.contentWrapper.setAttribute('aria-hidden', !this.classList.contains('accordion-item--open'))
  }
}

customElements.define('accordion-item', AccordionItem)
/* ==============================
End accordion item
============================== */

/* ==============================
Start Marquee scroll
============================== */
class MarqueeScroll extends HTMLElement {
  constructor() {
    super()
    this.content = this.querySelector('.marquee-scroll__content')
    this.currentCopies = 1

    if (this.content.children.length) {
      this.initMarquee()
      window.addEventListener('resize', this.onResize.bind(this))
    }
  }

  initMarquee() {
    const numberOfCopies = this.calcNumberOfCopies()
    this.addCopies(numberOfCopies)
    this.currentCopies = numberOfCopies
  }

  calcNumberOfCopies() {
    const marqueeWidth = this.offsetWidth
    const contentWidth = this.content.offsetWidth
    if (contentWidth === 0) return 2
    const copies = Math.ceil((marqueeWidth * 2) / contentWidth)
    return Math.max(2, copies)
  }

  addCopies(numberOfCopies) {
    this.querySelectorAll('.marquee-scroll__content:not(:first-child)').forEach((el) => el.remove())

    for (let i = 0; i < numberOfCopies - 1; i++) {
      const clone = this.content.cloneNode(true)
      clone.setAttribute('aria-hidden', 'true')
      this.appendChild(clone)
    }

    this.restartAnimation()
    this.setDuration()
  }

  restartAnimation() {
    this.querySelectorAll('.marquee-scroll__content').forEach((el) => {
      el.style.animation = 'none'
      void el.offsetWidth
      el.style.animation = ''
    })
  }

  setDuration() {
    const speed = this.getAttribute('speed') || 80

    requestAnimationFrame(() => {
      this.querySelectorAll('.marquee-scroll__content').forEach((el) => {
        const width = el.offsetWidth
        const duration = width / speed
        el.style.animationDuration = `${duration}s`
      })
    })
  }

  onResize() {
    cancelAnimationFrame(this._resizeFrame)
    this._resizeFrame = requestAnimationFrame(() => {
      const newCopies = this.calcNumberOfCopies()
      if (newCopies !== this.currentCopies) {
        this.addCopies(newCopies)
        this.currentCopies = newCopies
      } else {
        this.setDuration()
      }
    })
  }
}

customElements.define('marquee-scroll', MarqueeScroll)
/* ==============================
End Marquee scroll
============================== */

/* ==============================
Start product card swatches
============================== */
class ProductCardSwatches extends HTMLElement {
  constructor() {
    super()
    this.productCard = this.closest('.product-card')

    if (this.productCard) {
      this.addEventListener('change', this.onSwatchChange)
    }
  }

  onSwatchChange() {
    const selectedValues = Array.from(this.querySelectorAll('fieldset input:checked')).map(
      ({ dataset }) => dataset.valueId
    )
    if (selectedValues.length === 0) return
    const params = `&option_values=${selectedValues.join(',')}`
    const url = `${this.dataset.productUrl}?section_id=product-card-api${params}`

    this.productCard.classList.add('loading')

    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const jsonText = html.querySelector('.shopify-section').textContent.trim()
        const data = JSON.parse(jsonText)

        // Price
        const prices = this.productCard.querySelectorAll('.product-card__price')
        if (prices.length > 0 && data.price) {
          prices.forEach((price) => (price.innerHTML = data.price))
        }

        // Link
        const links = this.productCard.querySelectorAll('.product-card__link')
        if (links.length > 0 && data.link) {
          links.forEach((link) => (link.href = data.link))
        }

        // Quick buy variant id
        const quickBuyButton = this.productCard.querySelector('quick-buy-button')
        if (quickBuyButton && data.variantId) {
          quickBuyButton.dataset.variantId = data.variantId
        }

        // Media
        const media = this.productCard.querySelector('.product-card__media')
        if (media && data.media) {
          const tempWrapper = document.createElement('div')
          tempWrapper.innerHTML = data.media
          const newMedia = tempWrapper.firstElementChild
          const firstImage = newMedia?.querySelector('img')

          return new Promise((resolve) => {
            const completeSwap = () => {
              newMedia.classList.remove('product-card__media--staging')
              media.remove()
              resolve()
            }

            if (!firstImage) {
              media.replaceWith(newMedia)
              return resolve()
            }

            // Staging new media
            newMedia.classList.add('product-card__media--staging')
            media.insertAdjacentElement('afterend', newMedia)

            if (firstImage.complete) {
              completeSwap()
            } else {
              firstImage.onload = completeSwap
              firstImage.onerror = completeSwap
            }
          })
        }
      })
      .catch((error) => {
        console.error(error)
      })
      .finally(() => {
        this.productCard.classList.remove('loading')
      })
  }
}

customElements.define('product-card-swatches', ProductCardSwatches)
/* ==============================
End product card swatches
============================== */

/* ==============================
Start video media
============================== */
class VideoMedia extends HTMLElement {
  constructor() {
    super()
    this.poster = this.querySelector('.video-media__poster')
    this.loop = this.hasAttribute('loop')
    this.autoLoad = this.hasAttribute('auto-load')

    if (this.autoLoad) {
      this.initObserver()
    } else {
      this.poster?.addEventListener('click', this.loadContent.bind(this))
    }
  }

  initObserver() {
    const loadVideo = (entries, observer) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return
        this.loadContent()
        observer.unobserve(entry.target)
      })
    }

    const intersectionObserver = new IntersectionObserver(loadVideo, {
      root: null,
      threshold: 0,
      rootMargin: '200px',
    })

    intersectionObserver.observe(this)
  }

  loadContent() {
    if (this.getAttribute('loaded')) return

    // 1. Pause product media videos
    if (this.classList.contains('video-media--product-media') && this.autoLoad === false) {
      this.pauseProductMediaVideos()
    }

    // 2. Add video content
    const content = this.querySelector('template')?.content.firstElementChild?.cloneNode(true)
    if (!content) return
    this.appendChild(content)

    // 3. Video Listeners
    this.addVideoListeners(content)

    // 4. Focus
    if (content instanceof HTMLElement && this.autoLoad === false) {
      content.focus()
    }

    // 5. Loaded attribute
    this.setAttribute('loaded', true)

    // 6. Force autoplay for Safari
    if (content instanceof HTMLVideoElement && content.getAttribute('autoplay')) content.play()
  }

  pauseProductMediaVideos() {
    const productMedia = this.closest('.product-media')
    if (!productMedia) return
    const productMediaVideos = productMedia.querySelectorAll('.video-media--product-media')
    productMediaVideos.forEach((video) => video.pauseVideo())
  }

  addVideoListeners(content) {
    const iframe = content.tagName === 'IFRAME' ? content : content.querySelector('iframe')
    const video = content.tagName === 'VIDEO' ? content : content.querySelector('video')

    if (iframe) {
      iframe.addEventListener('load', () => this.hidePoster())
    }

    if (video) {
      video.addEventListener('loadeddata', () => this.hidePoster())
      video.addEventListener('canplay', () => this.hidePoster())
    }
  }

  hidePoster() {
    this.poster?.classList.add('hidden')
  }

  playVideo() {
    const iframe = this.querySelector('iframe[data-video-type]')
    if (iframe) {
      iframe.contentWindow?.postMessage(
        iframe.dataset.videoType === 'youtube'
          ? '{"event":"command","func":"playVideo","args":""}'
          : '{"method":"play"}',
        '*'
      )
    } else {
      this.querySelector('video')?.play()
    }
  }

  pauseVideo() {
    const iframe = this.querySelector('iframe[data-video-type]')
    if (iframe) {
      iframe.contentWindow?.postMessage(
        iframe.dataset.videoType === 'youtube'
          ? '{"event":"command","func":"pauseVideo","args":""}'
          : '{"method":"pause"}',
        '*'
      )
    } else {
      this.querySelector('video')?.pause()
    }
  }
}

customElements.define('video-media', VideoMedia)
/* ==============================
End video media
============================== */

/* ==============================
Start quantity input
============================== */

class QuantityInput extends HTMLElement {
  constructor() {
    super()
    this.input = this.querySelector('.quantity-input__input')
    this.btns = this.querySelectorAll('.quantity-input__btn')
    this.changeEvent = new Event('change', { bubbles: true })

    this.input.addEventListener('change', this.onInputChange.bind(this))
    this.input.addEventListener('blur', this.validateAndNormalize.bind(this))
    this.btns.forEach((btn) => {
      btn.addEventListener('click', this.onBtnClick.bind(this))
    })

    this.validateQtyRules()
  }

  onInputChange() {
    this.validateQtyRules()
  }

  onBtnClick(e) {
    e.preventDefault()
    const previousValue = this.input.value
    const btnName = e.currentTarget.name

    const min = parseInt(this.input.getAttribute('min')) || 1
    const max = parseInt(this.input.getAttribute('max')) || Infinity
    const step = parseInt(this.input.getAttribute('step')) || 1
    let value = parseInt(this.input.value) || min

    if (btnName === 'plus') {
      if (min > step && value === 0) {
        this.input.value = min
      } else {
        this.input.value = Math.min(max, value + step)
      }
    } else {
      this.input.value = Math.max(min, value - step)
    }

    if (previousValue !== this.input.value) {
      this.validateQtyRules()
      this.input.dispatchEvent(this.changeEvent)
    }
  }

  validateAndNormalize() {
    let value = parseInt(this.input.value)
    const min = parseInt(this.input.getAttribute('min')) || 1
    const max = parseInt(this.input.getAttribute('max')) || Infinity
    const step = parseInt(this.input.getAttribute('step')) || 1

    if (isNaN(value) || value < min) value = min
    if (value > max) value = max

    const remainder = (value - min) % step
    if (remainder !== 0) {
      value = value - remainder
    }

    if (this.input.value !== value.toString()) {
      this.input.value = value
      this.validateQtyRules()
      this.input.dispatchEvent(this.changeEvent)
    }
  }

  validateQtyRules() {
    const value = parseInt(this.input.value) || 1
    const min = parseInt(this.input.getAttribute('min')) || 1
    const max = parseInt(this.input.getAttribute('max')) || Infinity

    const btnMinus = this.querySelector(".quantity-input__btn[name='minus']")
    const btnPlus = this.querySelector(".quantity-input__btn[name='plus']")

    if (btnMinus) btnMinus.disabled = value <= min
    if (btnPlus) btnPlus.disabled = value >= max
  }
}

customElements.define('quantity-input', QuantityInput)
/* ==============================
End quantity input
============================== */

/* ==============================
Start dialog
============================== */
class dialogComponent extends HTMLElement {
  constructor() {
    super()
    this.triggerElement = null
    this.closeBtns = this.querySelectorAll('.dialog-component__close')
    this.overlay = this.querySelector('.dialog-component__overlay')

    this.handleAppendToBody()

    if (this.closeBtns.length > 0) {
      this.closeBtns.forEach((btn) => btn.addEventListener('click', () => this.closeDialog()))
    }
    if (this.overlay) this.overlay.addEventListener('click', () => this.closeDialog())
    window.addEventListener('keyup', (e) => {
      if (e.key === 'Escape') this.closeDialog()
    })

    document.addEventListener('shopify:block:select', this.closeDialog.bind(this))
    document.addEventListener('shopify:section:select', this.closeDialog.bind(this))
  }

  handleAppendToBody() {
    if (this.hasAttribute('append-to-body') && this.parentNode !== document.body) {
      const oldInstance = document.querySelector(`body > #${this.id}`)
      if (oldInstance) {
        if (oldInstance.hasAttribute('open')) {
          oldInstance.closeDialog()
        }
        oldInstance.remove()
      }
      document.body.appendChild(this)
    }
  }

  openDialog(opener) {
    if (this.hasAttribute('open')) return
    this.removeAttribute('inert')
    this.triggerElement = opener
    this.setAttribute('open', '')
    trapFocus(this)
    lockScroll()
  }

  closeDialog() {
    if (!this.hasAttribute('open')) return
    this.setAttribute('inert', '')
    this.removeAttribute('open')
    removeTrapFocus(this)
    setTimeout(() => unlockScroll(), 300)
  }
}

customElements.define('dialog-component', dialogComponent)

class DialogOpener extends HTMLElement {
  constructor() {
    super()
    this.button = this.querySelector('button')
    if (!this.button) return

    this.button.addEventListener('click', this.openDialog.bind(this))

    if (this.classList.contains('open-on-load')) {
      this.openDialog()
      this.classList.remove('open-on-load')
    }
  }

  openDialog() {
    const dialogId = this.dataset.dialog
    const dialog = document.querySelector(dialogId)
    if (dialog) dialog.openDialog(this.button)
  }
}

customElements.define('dialog-opener', DialogOpener)
/* ==============================
End dialog
============================== */

/* ==============================
Start swiper navigation
============================== */
document.addEventListener('keydown', function (event) {
  if (event.key === ' ' || event.code === 'Space') {
    const isSwiperButton = event.target.closest('.swiper-button-next, .swiper-button-prev')
    if (isSwiperButton) event.preventDefault()
  }
})
/* ==============================
End swiper navigation
============================== */

/* ==============================
Start quick buy
============================== */
class QuickBuyButton extends HTMLElement {
  constructor() {
    super()
    this.opener = this.querySelector('.quick-buy-btn')
    this.productUrl = this.dataset.productUrl

    this.modalSection = document.querySelector('.quick-buy-modal-section')
    this.modalSectionId = this.modalSection?.dataset.sectionId

    this.modalId = this.modalSection?.dataset.modalId
    this.modal = this.modalSection?.querySelector(`#${this.modalId}`)

    this.previewModalId = this.modalSection?.dataset.previewModalId
    this.previewModal = this.modalSection?.querySelector(`#${this.previewModalId}`)

    this.isLoading = false

    if (this.opener && this.modal) {
      this.upgradeToButton()
    }
    this.opener?.addEventListener('click', this.onOpenerClick.bind(this))
  }

  upgradeToButton() {
    const button = document.createElement('button')
    button.type = 'button'
    button.className = this.opener.className
    button.innerHTML = this.opener.innerHTML

    button.setAttribute('aria-label', this.opener.getAttribute('aria-label') || '')
    button.setAttribute('aria-haspopup', 'dialog')

    this.opener.replaceWith(button)
    this.opener = button
  }

  onOpenerClick(e) {
    if (!this.modal) return
    if (this.isLoading) return

    this.isLoading = true
    this.opener.classList.add('loading-spinner')
    this.opener.setAttribute('aria-disabled', 'true')

    const variantId = this.dataset.variantId
    const url = `${this.productUrl}?variant=${variantId}&section_id=${this.modalSectionId}`

    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const target = this.modal.querySelector('.product-view')
        const source = html.querySelector('.product-view')

        if (target && source) {
          target.innerHTML = source.innerHTML
        }

        if (this.modal.hasAttribute('open')) this.modal.closeDialog()
        if (this.previewModal && this.previewModal.hasAttribute('open')) this.previewModal.closeDialog()
        this.modal.openDialog(this.opener)
      })
      .catch((error) => {
        console.error(error)
      })
      .finally(() => {
        this.isLoading = false
        this.opener.classList.remove('loading-spinner')
        this.opener.removeAttribute('aria-disabled')
      })
  }
}

customElements.define('quick-buy-button', QuickBuyButton)

class QuickBuyModalSection extends HTMLElement {
  constructor() {
    super()
    this.sectionId = this.dataset.sectionId
    this.previewModalId = this.dataset.previewModalId
    this.previewModal = this.querySelector(`#${this.previewModalId}`)
    this.timer = null

    this.openInThemeEditor = this.openInThemeEditor.bind(this)
    this.closeInThemeEditor = this.closeInThemeEditor.bind(this)
  }

  connectedCallback() {
    document.addEventListener('shopify:section:select', this.openInThemeEditor)
    document.addEventListener('shopify:section:load', this.openInThemeEditor)
    document.addEventListener('shopify:section:deselect', this.closeInThemeEditor)
    document.addEventListener('shopify:block:select', this.openInThemeEditor)
  }

  disconnectedCallback() {
    document.removeEventListener('shopify:section:select', this.openInThemeEditor)
    document.removeEventListener('shopify:section:load', this.openInThemeEditor)
    document.removeEventListener('shopify:section:deselect', this.closeInThemeEditor)
    document.removeEventListener('shopify:block:select', this.openInThemeEditor)
    if (this.timer) clearTimeout(this.timer)
  }

  openInThemeEditor(e) {
    if (this.sectionId === e.detail.sectionId) {
      if (this.timer) clearTimeout(this.timer)
      this.timer = setTimeout(() => this.previewModal.openDialog(), 300)
    }
  }

  closeInThemeEditor(e) {
    if (this.sectionId === e.detail.sectionId) {
      if (this.timer) clearTimeout(this.timer)
      this.timer = setTimeout(() => this.previewModal.closeDialog(), 300)
    }
  }
}

customElements.define('quick-buy-modal-section', QuickBuyModalSection)
/* ==============================
End quick buy
============================== */

/* ==============================
Start RTE table wrapper
============================== */
function tableWrapper() {
  const tables = document.querySelectorAll('.rte table')

  if (!tables.length) return

  tables.forEach((table) => {
    const wrapper = document.createElement('div')
    wrapper.className = 'table-wrapper'
    table.parentNode.insertBefore(wrapper, table)
    wrapper.appendChild(table)
  })
}

document.addEventListener('DOMContentLoaded', tableWrapper)
/* ==============================
End RTE table wrapper
============================== */

/* ==============================
Start drag slider
============================== */
class DragSlider extends HTMLElement {
  constructor() {
    super()
    this.isDown = false
    this.isDragging = false
    this.startX = 0
    this.scrollLeftState = 0

    this.onMouseDown = this.onMouseDown.bind(this)
    this.onMouseLeave = this.onMouseLeave.bind(this)
    this.onMouseUp = this.onMouseUp.bind(this)
    this.onMouseMove = this.onMouseMove.bind(this)
    this.onClick = this.onClick.bind(this)
  }

  connectedCallback() {
    this.addEventListener('mousedown', this.onMouseDown)
    this.addEventListener('mouseleave', this.onMouseLeave)
    this.addEventListener('mouseup', this.onMouseUp)
    this.addEventListener('mousemove', this.onMouseMove)

    this.addEventListener('dragstart', (e) => e.preventDefault())
    this.addEventListener('click', this.onClick, { capture: true })
  }

  onMouseDown(e) {
    if (e.button !== 0) return

    this.isDown = true
    this.isDragging = false
    this.classList.remove('is-dragging')

    this.startX = e.pageX - this.offsetLeft
    this.scrollLeftState = this.scrollLeft
  }

  onMouseLeave() {
    this.isDown = false
    this.classList.remove('is-dragging')
  }

  onMouseUp() {
    this.isDown = false
    this.classList.remove('is-dragging')
  }

  onMouseMove(e) {
    if (!this.isDown) return
    e.preventDefault()

    const x = e.pageX - this.offsetLeft
    const walk = (x - this.startX) * 1.5

    if (Math.abs(walk) > 4) {
      this.isDragging = true
      this.classList.add('is-dragging')
    }

    this.scrollLeft = this.scrollLeftState - walk
  }

  onClick(e) {
    if (this.isDragging) {
      e.preventDefault()
      e.stopPropagation()
    }
  }
}

customElements.define('drag-slider', DragSlider)
/* ==============================
End drag slider
============================== */

/* ==============================
Start global theme editor events
============================== */
document.addEventListener('shopify:section:load', (e) => {
  const target = e.target

  if (target?.classList?.contains('popup-section')) {
    customElements.whenDefined('pop-up').then(() => {
      target.querySelector('pop-up').dialog.openDialog()
    })
  }
})
/* ==============================
End global theme editor events
============================== */

/* ==============================
Start text animation
============================== */
class TextAnimation extends HTMLElement {
  constructor() {
    super()

    this.intersectionObserver = null
    this.resizeObserver = null
    this.mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)')
    this.handleReducedMotion = this.handleReducedMotion.bind(this)

    this.animationDuration = 0.8
    this.lineDelayStep = 0.08
    this.totalAnimationTime = 0

    this.animationTimeout = null
    this.resizeDebounce = null
  }

  connectedCallback() {
    if (this.hasAttribute('data-initialized')) return
    this.setAttribute('data-initialized', 'true')

    this.mediaQuery.addEventListener('change', this.handleReducedMotion)
    if (this.mediaQuery.matches) {
      this.showImmediately()
      return
    }

    const isDOMPrepared = this.prepareDOM()
    if (!isDOMPrepared) return
    this.initIntersectionObserver()
    this.initResizeObserver()
  }

  disconnectedCallback() {
    this.intersectionObserver?.disconnect()
    this.resizeObserver?.disconnect()
    this.mediaQuery.removeEventListener('change', this.handleReducedMotion)

    clearTimeout(this.animationTimeout)
    clearTimeout(this.resizeDebounce)
  }

  handleReducedMotion(e) {
    if (e.matches) this.showImmediately()
  }

  prepareDOM() {
    const walker = document.createTreeWalker(this, NodeFilter.SHOW_TEXT, {
      acceptNode: (node) => {
        if (!node.nodeValue.trim()) return NodeFilter.FILTER_REJECT
        const parent = node.parentElement
        if (!parent) return NodeFilter.FILTER_REJECT
        if (!parent.closest('.text-block')) return NodeFilter.FILTER_REJECT
        if (['SCRIPT', 'STYLE', 'NOSCRIPT', 'TEMPLATE'].includes(parent.tagName)) return NodeFilter.FILTER_REJECT
        if (parent.closest('.word-mask')) return NodeFilter.FILTER_REJECT
        return NodeFilter.FILTER_ACCEPT
      },
    })

    const textNodes = []
    let node
    while ((node = walker.nextNode())) {
      textNodes.push(node)
    }

    if (textNodes.length > 150) {
      this.showImmediately()
      return false
    }

    textNodes.forEach((textNode) => this.wrapTextNode(textNode))
    this.calculateDelays()
    return true
  }

  wrapTextNode(textNode) {
    const fragment = document.createDocumentFragment()
    // Split by whitespace while preserving the original spacing
    const parts = textNode.nodeValue.split(/(\s+)/)

    parts.forEach((part) => {
      if (!part) return

      // Keep spaces as raw text nodes
      if (/^\s+$/.test(part)) {
        fragment.appendChild(document.createTextNode(part))
        return
      }

      const mask = document.createElement('span')
      mask.className = 'word-mask'

      const inner = document.createElement('span')
      inner.className = 'word-inner'
      inner.textContent = part

      mask.appendChild(inner)
      fragment.appendChild(mask)
    })

    textNode.replaceWith(fragment)
  }

  calculateDelays() {
    const masks = this.querySelectorAll('.word-mask')
    if (!masks.length) return

    this.resetDelays(masks)
    this.setWordDelays(masks)
    this.setLinkUnderlineDelays()
  }

  resetDelays(masks) {
    masks.forEach((mask) => {
      const inner = mask.querySelector('.word-inner')
      if (inner) inner.style.setProperty('--word-delay', '0s')
    })
  }

  setWordDelays(masks) {
    let currentLineTop = null
    let lineIndex = -1
    let totalDelay = 0

    masks.forEach((mask) => {
      const inner = mask.querySelector('.word-inner')
      if (!inner) return

      const top = mask.offsetTop

      if (currentLineTop === null || Math.abs(top - currentLineTop) > 10) {
        currentLineTop = top
        lineIndex++
      }

      const delay = lineIndex * this.lineDelayStep
      inner.style.setProperty('--word-delay', `${delay}s`)

      if (delay > totalDelay) {
        totalDelay = delay
      }
    })

    this.totalAnimationTime = totalDelay + this.animationDuration
  }

  setLinkUnderlineDelays() {
    this.querySelectorAll('.text-block a').forEach((link) => {
      const innerWords = link.querySelectorAll('.word-inner')
      if (!innerWords.length) return

      let maxWordDelay = 0
      innerWords.forEach((word) => {
        const delayValue = parseFloat(word.style.getPropertyValue('--word-delay')) || 0
        if (delayValue > maxWordDelay) maxWordDelay = delayValue
      })

      const totalLinkDelay = maxWordDelay + this.animationDuration
      link.style.setProperty('--underline-delay', `${totalLinkDelay}s`)
    })
  }

  initIntersectionObserver() {
    const textBlocks = this.querySelectorAll('.text-block')
    const elementsToObserve = textBlocks.length > 0 ? Array.from(textBlocks) : [this]

    this.intersectionObserver = new IntersectionObserver(
      (entries) => {
        const isIntersecting = entries.some((entry) => entry.isIntersecting)

        if (isIntersecting) {
          this.classList.add('animation-started')

          const cleanupTime = (this.totalAnimationTime || 0) * 1000

          this.animationTimeout = setTimeout(() => {
            this.classList.add('animation-ended')
          }, cleanupTime)

          this.intersectionObserver.disconnect()
        }
      },
      {
        threshold: 0,
        rootMargin: '0px 0px -15% 0px',
      }
    )

    elementsToObserve.forEach((el) => this.intersectionObserver.observe(el))
  }

  initResizeObserver() {
    this.resizeObserver = new ResizeObserver(() => {
      if (this.classList.contains('animation-started')) return

      clearTimeout(this.resizeDebounce)
      this.resizeDebounce = setTimeout(() => {
        this.calculateDelays()
      }, 150)
    })

    this.resizeObserver.observe(this)
  }

  showImmediately() {
    this.classList.add('animation-disabled')
  }
}

customElements.define('text-animation', TextAnimation)
/* ==============================
End text animation
============================== */
